import React from 'react';
import Route from 'react-router/lib/Route';

import routeCallback from 'common/src/app/util/routeCallback';
import Pages from 'common/src/app/data/enum/Pages';

import StaticContent from 'bundle-loader?lazy&name=StaticContent!./index';

const routes = (
  <Route getComponent={routeCallback(StaticContent)}>
    <Route path={Pages.USER_SUBSCRIPTION_AGREEMENT} />
  </Route>
);

export default routes;
